import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "content-imgs"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return ($setup.props.houseInfo)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode($setup["BuilderSelectionHouse"], {
          selectedHouseDesign: $setup.props.houseInfo,
          quote: $setup.props.quote,
          isBuilderQuoteView: true,
          selectedFacade: $props.selectedFacade,
          onUpdateSelectedFacade: $setup.onUpdateSelectedFacade
        }, null, 8, ["selectedHouseDesign", "quote", "selectedFacade"])
      ]))
    : _createCommentVNode("", true)
}